import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-inactividad',
  standalone: true,
  imports: [CommonModule],
  styles: [
    `
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease;
        z-index: 1000;
      }

      .modal-overlay.show {
        opacity: 1;
        visibility: visible;
      }

      .modal-content {
        background: white;
        padding: 2rem;
        border-radius: 12px;
        text-align: center;
        transform: translateY(-20px);
        transition: all 0.3s ease;
        max-width: 400px;
        width: 90%;
      }

      .modal-overlay.show .modal-content {
        transform: translateY(0);
      }

      .wave-hand {
        margin-bottom: 1rem;
      }

      .wave-hand img {
        width: 64px;
        height: 64px;
        animation: wave 2s infinite;
      }

      h2 {
        color: #004379;
        margin-bottom: 0.5rem;
      }

      p {
        color: #666;
        margin-bottom: 1.5rem;
      }

      .modal-actions {
        display: flex;
        gap: 1rem;
        justify-content: center;
      }

      .button-main {
        min-width: 180px !important;
        max-height: 40px !important;
        font-size: 14px !important;
      }

      .button-secundary {
        min-width: 180px !important;
        max-height: 40px !important;
        font-size: 14px !important;
      }

      @keyframes wave {
        0% {
          transform: rotate(0deg);
        }
        10% {
          transform: rotate(14deg);
        }
        20% {
          transform: rotate(-8deg);
        }
        30% {
          transform: rotate(14deg);
        }
        40% {
          transform: rotate(-4deg);
        }
        50% {
          transform: rotate(10deg);
        }
        60% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(0deg);
        }
      }

      .modal-overlay.closing {
        opacity: 0;
      }

      .modal-content.closing {
        transform: translateY(20px);
      }

      @media (max-width: 1040px) {
        .modal-content {
          width: 300px;
        }
        .button-main,
        .button-secundary {
          min-width: 100px !important;
        }
      }
    `,
  ],
  template: `
    <div
      class="modal-overlay"
      [class.show]="isOpen"
      [class.closing]="isClosing"
    >
      <div class="modal-content" [class.closing]="isClosing">
        <div class="wave-hand">
          <img src="assets/waving-hand.svg" alt="waving hand" />
        </div>
        <h2>¡Hola! ¿Sigues ahí?</h2>
        <p>Tu sesión está a punto de expirar por inactividad</p>
        <div class="modal-actions">
          <button class="button-main" (click)="onConfirm()">
            Extender sesión
          </button>
          <button class="button-secundary" (click)="onCancel()">
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  `,
})
export class ModalInactividadComponent {
  isOpen = false;
  isClosing = false;

  onConfirm(): void {
    this.closeWithAnimation(() => {
      this.isOpen = false;
      // Aquí puedes emitir un evento o llamar a un servicio
    });
  }

  onCancel(): void {
    this.closeWithAnimation(() => {
      this.isOpen = false;
      // Aquí puedes emitir un evento o llamar a un servicio
    });
  }

  private closeWithAnimation(callback: () => void): void {
    this.isClosing = true;
    setTimeout(() => {
      this.isClosing = false;
      callback();
    }, 300);
  }

  show(): void {
    this.isOpen = true;
  }
}
